namespace SP {
    export interface StockPlacement {
        id: number;
        row: number;
        number: number;
        sub: number;
        stockUnitId: string;
        itemSize: number;
        active: boolean;
    }
}